import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useWithdrawSendOtp = (): UseMutationResult<[] | any, ErrorResponse> => {
  return useMutation(() => api.post(url.withdrawSendOtp));
};

export default useWithdrawSendOtp;
